import { render, staticRenderFns } from "./pdc_index.vue?vue&type=template&id=6a0bb0d5&"
import script from "./pdc_index.vue?vue&type=script&lang=js&"
export * from "./pdc_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports